import axios from 'axios';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL || '/api',
  headers: {
    'Content-Type': 'application/json'
  }
});

// Add token to requests
api.interceptors.request.use(
  (config) => {
    const token = localStorage.getItem('token');
    if (token) {
      config.headers.Authorization = `Bearer ${token}`;
    }
    // Ensure baseURL defaults correctly even if env is empty string
    if (!config.baseURL || config.baseURL === '') {
      config.baseURL = '/api';
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

export default api;








